import { useQuery } from '@apollo/client';
import { graphql } from 'gql.tada';
import type { ResultOf } from 'gql.tada';

// Every invoice in the school year, one row each, read from the local mirror
// (never Stripe). The flags on a row are the backend's rulings — whether it can
// be posted and why not, what its status reads as — so this page and a family's
// Billing tab cannot disagree.
const SchoolInvoicesQuery = graphql.persisted(
  "SchoolInvoices",
  graphql(`
    query SchoolInvoices($schoolYearId: ID!) {
      schoolInvoices(schoolYearId: $schoolYearId) {
        invoiceId
        familyEnrollmentId
        familyName
        familySlug
        kind
        key
        scheduleKey
        memo
        status
        displayStatus
        dueDate
        amountCents
        feeCents
        totalCents
        stripeInvoiceId
        stripeCollectionMethod
        stripeHostedInvoiceUrl
        postable
        postDisabledReason
        editable
        requiresAutoPay
        autoPayWaived
        autopayEnabled
        autoCollectable
        automaticPaymentAuthorized
        paymentMethodOnFile
        paymentMethodType
        paymentMethodLast4
        postedAt
        createdAt
      }
    }
  `)
);

export type SchoolInvoiceRow = ResultOf<typeof SchoolInvoicesQuery>['schoolInvoices'][number];

export { SchoolInvoicesQuery };

export function useSchoolInvoicesQuery(schoolYearId: string | undefined) {
  return useQuery(SchoolInvoicesQuery, {
    variables: { schoolYearId: schoolYearId! },
    skip: !schoolYearId,
  });
}
